import { makeStyles } from "@mui/styles";

export const LearningStyle = makeStyles((theme) => ({
  mainLayout: {
    overflow: "hidden",
    position: "relative",
    height: "100%",
    zIndex: 1,
    background:
      "linear-gradient(92deg, #F6FCFF 7.06%, rgba(255, 244, 238, 0.50) 86.87%)",
    backgroundSize: "cover",
  },
  learningTopNav: {
    position: "absolute",
    top: 64,
    left: 0,
    right: 0,
    zIndex: 9,
  },
  learningBtn: {
    background:
      "linear-gradient(103.28deg, rgba(226, 236, 253, 0.16) 0%, rgba(170, 193, 247, 0.16) 59.55%)",
    borderRadius: 4,
    padding: "12px 24px",
    textTransform: "uppercase",
    fontWeight: "bold",
    cursor: "pointer",
    color: "var(--gray)",
    "&.active": {
      background:
        "linear-gradient(103.28deg, rgba(226, 236, 253, 0.16) 0%, rgba(170, 193, 247, 0.16) 59.55%)",
      borderBottom: `3px solid #555FDD`,
      color: "#555FDD",
    },
  },
  navBtn: {
    "& .MuiButtonBase-root": {
      borderRadius: 4,
      borderBottom: `3px solid transparent`,
      "&.active": {
        background:
          "linear-gradient(103.28deg, rgba(226, 236, 253, 0.16) 0%, rgba(170, 193, 247, 0.16) 59.55%)",
        color: theme.palette.blue.main,
        borderColor: theme.palette.blue.main,
      },
    },
  },
  heroSection: {
    width: "100%",
    minHeight: 832,
    padding: "56px 48px",
    position: "relative",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top center",
    backgroundSize: "cover",
    zIndex: 1,
    overflow: "hidden",
    [theme.breakpoints.down("lg")]: {
      minHeight: 732,
    },
    [theme.breakpoints.down("md")]: {
      minHeight: 632,
    },
    [theme.breakpoints.down("sm")]: {
      minHeight: 532,
    },
    "&:before": {
      content: "''",
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      background:
        "linear-gradient(160.24deg, rgba(255, 255, 255, 0.9) 19.81%, rgba(255, 255, 255, 0) 39.74%), linear-gradient(95.77deg, rgba(255, 255, 255, 0.8) 27.97%, rgba(255, 255, 255, 0) 54.83%), linear-gradient(193.75deg, rgba(255, 255, 255, 0) 60.52%, rgb(255 255 255 / 85%) 84.34%), linear-gradient(32.76deg, rgba(255, 255, 255, 0) 69.72%, rgba(255, 255, 255, 0.8) 87.23%), linear-gradient(171.6deg, rgba(255, 255, 255, 0) 76.23%, rgb(255 255 255 / 85%) 89.7%)",
      zIndex: -1,
    },
  },
  heroImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: -2,
  },

  filterIcon: {
    "&.MuiIconButton-root": {
      borderRadius: 8,
      border: `1px solid ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
    },
  },
  heroSectionContent: {
    height: "100%",
    position: "absolute",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    top: 0,
    left: "5%",
    right: 0,
    zIndex: 1,
  },
  lgHeading: {
    "&.MuiTypography-root": {
      fontSize: 48,
      fontWeight: 700,
      lineHeight: "56px",
      color: "#2D2F39",
      [theme.breakpoints.down("xl")]: {
        fontSize: 40,
        lineHeight: "50px",
      },
      [theme.breakpoints.down("xlg")]: {
        fontSize: 35,
        lineHeight: "45px",
      },
      [theme.breakpoints.down("lg")]: {
        fontSize: 30,
        lineHeight: "40px",
      },
      [theme.breakpoints.down("xsm")]: {
        fontSize: 26,
        lineHeight: "34px",
      },
      "& .orangeText": {
        color: "var(--primary)",
        fontWeight: 700,
      },
    },
  },
  bannerBg: {
    position: "relative",
    display: "flex",
    // margin: "76px 24px 0 24px",
    "& .desc": {
      fontSize: 20,
      color: "var(--gray)",
      marginBottom: 32,
      marginTop: 24,
      fontWeight: 400,
      [theme.breakpoints.down("lg")]: {
        fontSize: 18,
        marginBottom: 15,
        marginTop: 15,
      },
      [theme.breakpoints.down("xsm")]: {
        fontSize: 16,
      },
      "& span": {
        color: "var(--primary)",
      },
    },
    "& .MuiButtonBase-root": {
      padding: "12px 32px",
      borderRadius: "10px",
      background:
        "linear-gradient(132.61deg, var(--primaryDarker) 32.09%, var(--primaryGradientLighter) 163.78%)",
      [theme.breakpoints.down("sm")]: {
        padding: "10px 22px",
      },
    },
  },
  sliderHeader: {
    width: "100%",
    paddingBottom: "16px",
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
    },
    "& h2": {
      fontSize: 24,
      color: "var(--black)",
      fontWeight: 700,
      paddingBottom: "8px",
      [theme.breakpoints.down("sm")]: {
        fontSize: 20,
      },
    },
    "& h4": {
      fontSize: 20,
      color: "var(--primary)",
      fontWeight: 500,
      cursor: "pointer",
      flex: "none",
    },
    "& h5": {
      fontSize: 16,
      fontWeight: 400,
      color: "var(--gray)",
    },
    "& svg": {
      verticalAlign: "middle",
    },
    "& a": {
      color: theme.palette.orange.main,
      "& svg": {
        width: 16,
        height: 16,
        marginLeft: 3,
      },
    },
  },
  yourPersonalitySliderMain: {
    position: "relative",
    "& .button-prev": {
      position: "absolute",
      top: "50%",
      left: -60,
      color: "#747787",
      transform: "translateY(-50%)",
      boxShadow: `0px 0px 14px 0px #0000001A`,
      width: 40,
      height: 40,
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      zIndex: 9,
      backgroundColor: theme.palette.white.main,
      [theme.breakpoints.down("md")]: {
        left: -20,
      },
      "&:after": {
        width: 20,
        height: 20,
      },
    },
    "& .button-next": {
      position: "absolute",
      top: "50%",
      right: -60,
      color: "#747787",
      transform: "translateY(-50%)",
      boxShadow: `0px 0px 14px 0px #0000001A`,
      width: 40,
      height: 40,
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      zIndex: 9,
      backgroundColor: theme.palette.white.main,
      [theme.breakpoints.down("md")]: {
        right: -20,
      },
      "&:after": {
        width: 20,
        height: 20,
      },
    },
    "& .swiper": {
      overflow: "visible",
      "& .swiper-slide": {
        height: "auto",
      },
      "& .swiper-pagination": {
        bottom: 0,
        "& .swiper-pagination-bullet": {
          background: "#CBCBCF",
          opacity: 1,
          width: 24,
          height: 4,
          transition: "all 0.4s ease-in-out",
          borderRadius: 4,
          "& .swiper-pagination-horizontal": {
            bottom: "228px !important",
            left: 0,
            width: "100%",
          },
        },
        "& .swiper-pagination-bullet-active": {
          background: "var(--primary)",
          width: 100,
          "& .swiper-pagination-horizontal": {
            bottom: "228px !important",
            left: 0,
            width: "100%",
          },
        },
        "& .swiper-pagination-horizontal": {
          bottom: "228px !important",
          left: 0,
          width: "100%",
        },
      },
    },
  },
  zoomEffectSlider: {
    "& .swiper": {
      "& .swiper-slide": {
        transition: "all 0.8s ease-in-out",
        "&:hover": {
          transform: "scale(1.25)",
          position: "relative",
          zIndex: 99,
          [theme.breakpoints.down("md")]: {
            transform: "scale(1)",
          },
          "& ~ .swiper-slide": {
            transform: "translateX(10%)",
          },
          "& $zoomVideoBoxInfo": {
            maxHeight: 1000,
            transition: "all 0.8s ease-in-out",
            backdropFilter: "blur(5px)",
            backgroundColor: "transparent",
            "& $contentHead": {
              fontSize: 16,
              lineHeight: "1.2",
              fontWeight: 700,
              maxWidth: "100%",
              marginTop: "14%",
              WebkitLineClamp: 4,
            },
            "& $subText": {
              height: "100%",
              maxHeight: "4lh",
              opacity: 1,
              visibility: "visible",
              marginTop: 10,
              fontSize: 16,
              color: theme.palette.white.main,
              WebkitLineClamp: 4,
              lineHeight: "120% !important",
            },
          },
          "& $typeIcon": {
            "& .MuiTypography-root": {
              opacity: 1,
              width: "auto",
              marginLeft: 4,
            },
          },
          "& $typeIcon, & $btnWrap, & $partnerLogo": {
            transform: "scale(0.85)",
            transition: "all 0.8s ease-in-out",
            transformOrigin: "left",
          },
          "& .Infographic": {
            "& $zoomVideoBoxInfo": {
              background: `linear-gradient(273.45deg, rgba(255, 177, 66, 0.7) 0%, rgba(255, 200, 123, 0.9) 203.8%)`,
            },
            "& $typeIcon": {
              background: theme.palette.white.main,
              color: "#E39424",
              opacity: 0.8,
            },
          },
          "& .Article": {
            "& $zoomVideoBoxInfo": {
              background: `#E87637A6`,
            },
            "& $typeIcon": {
              background: theme.palette.white.main,
              opacity: 0.8,
              color: "#E87637",
            },
          },
          "& .Presentation": {
            "& $zoomVideoBoxInfo": {
              background: `linear-gradient(273.45deg, rgba(85, 95, 221, 0.75) 0%, rgba(136, 160, 241, 0.75) 203.8%)`,
            },
            "& $typeIcon": {
              background: theme.palette.white.main,
              color: "#555FDD",
              opacity: 0.8,
            },
          },
          "& .Video": {
            "& $zoomVideoBoxInfo": {
              background: `linear-gradient(273.51deg, rgba(139, 63, 158, 0.57) 0%, rgba(139, 63, 158, 0.76) 100%)`,
            },
            "& $typeIcon": {
              background: theme.palette.white.main,
              color: "#8B3F9E",
              opacity: 0.8,
            },
          },
          "& .Audio": {
            "& $zoomVideoBoxInfo": {
              background: `background: linear-gradient(273.45deg, rgba(36, 113, 63, 0.6) 0%, rgba(52, 162, 89, 0.6) 203.8%)`,
            },
            "& $typeIcon": {
              background: theme.palette.white.main,
              color: "#2D8F4E",
              opacity: 0.8,
            },
          },
          "& .Course": {
            "& $zoomVideoBoxInfo": {
              background: `linear-gradient(273.45deg, rgba(23, 128, 198, 0.75) 0%, rgba(83, 163, 216, 0.75) 203.8%)`,
            },
            "& $typeIcon": {
              background: theme.palette.white.main,
              color: "#1780C6",
              opacity: 0.8,
            },
          },
        },
      },
      "&:hover": {
        "& .swiper-slide": {
          transform: "translateX(-10%)",
        },
      },
    },
  },
  contentHead: {
    maxWidth: "calc(100% - 60px)",
    width: "100%",
  },
  partnerLogo: {
    marginLeft: "auto",
    position: "absolute",
    top: 10,
    right: 10,
    "& img": {
      height: 25,
      width: "auto !important",
    },
  },
  videoSlider: {
    "& .swiper": {
      "& .swiper-pagination": {
        position: "static",
        "& .swiper-pagination-bullet-active": {
          width: 64,
        },
      },
    },
  },
  videoContainer: {
    "& video": {
      borderRadius: 20,
      aspectRatio: "16/9",
      width: "100%",
      objectFit: "cover",
      display: "block",
      [theme.breakpoints.down("md")]: {
        aspectRatio: "3/2",
      },
    },
  },
  videoControl: {
    gap: 15,
    [theme.breakpoints.down("md")]: {
      gap: 10,
    },
    "& p": {
      [theme.breakpoints.down("md")]: {
        fontSize: 12,
      },
    },
    "& svg": {
      [theme.breakpoints.down("md")]: {
        width: 20,
        height: 20,
      },
    },
  },
  personalityMain: {
    "& .swiper-wrapper": {
      "& .swiper-slide": {
        "&:last-child": {
          "&:after": {
            display: "none",
          },
        },
      },
    },
    "& .swiper-pagination": {
      bottom: "18% !important",
      zIndex: 9,
    },
    "& .swiper-button-prev, .swiper-button-next": {
      "&:after": {
        // background: `url(${arrow})`,
        fontSize: 0,
        height: 27,
        width: 27,
        backgroundSize: "contain",
      },
    },
    "& .swiper-button-next": {
      transform: "rotate(180deg)",
    },
  },
  personalitySlider: {
    marginBottom: 15,
    [theme.breakpoints.down("md")]: {
      marginBottom: 0,
    },
    "& h5": {
      fontSize: 20,
      lineHeight: "26px",
      fontWeight: 700,
      color: "#4F4F4F",
      marginBottom: 8,

      [theme.breakpoints.down("md")]: {
        fontSize: 18,
        lineHeight: "23px",
      },
    },
  },
  personalityBoxes: {
    padding: [[0, 17]],
    boxShadow: "none",
    border: 0,
    position: "relative",
    height: "100%",
  },
  videosBox: {
    padding: 0,
    border: "none",
    backgroundColor: "transparent",
    boxShadow: "0px 7.798px 17.329px 0px rgba(81, 125, 132, 0.07)",
    position: "relative",
    borderRadius: 10,
    "&:before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
    },
    "&:after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
    },
    "& .MuiBox-root img": {
      width: "100%",
      display: "block",
    },
    "&.Infographic": {
      background: `linear-gradient(273.45deg, #FFB142 0%, #FFC87B 203.8%)`,
      padding: 3,
      "& $zoomVideoBoxInfo": {
        background: `linear-gradient(273.45deg, #FFB142 0%, #FFC87B 203.8%)`,
      },
      "& $typeIcon": {
        background: `linear-gradient(273.45deg, #FFB142 0%, #FFC87B 203.8%)`,
        color: theme.palette.white.main,
      },
    },
    "&.Article": {
      background: `#E87637`,
      padding: 3,
      "& $zoomVideoBoxInfo": {
        background: `#E87637`,
      },
      "& $typeIcon": {
        background: `#E87637`,
        color: theme.palette.white.main,
      },
    },
    "&.Presentation": {
      background: `linear-gradient(273.45deg, #555FDD 0%, #88A0F1 203.8%)`,
      padding: 3,
      "& $zoomVideoBoxInfo": {
        background: `linear-gradient(273.45deg, #555FDD 0%, #88A0F1 203.8%)`,
      },
      "& $typeIcon": {
        background: `linear-gradient(273.45deg, #555FDD 0%, #88A0F1 203.8%)`,
        color: theme.palette.white.main,
      },
    },
    "&.Video": {
      background: `linear-gradient(273.45deg, #8B3F9E 0%, #B77EC5 203.8%)`,
      padding: 3,
      "& $zoomVideoBoxInfo": {
        background: `linear-gradient(273.45deg, #8B3F9E 0%, #B77EC5 203.8%)`,
      },
      "& $typeIcon": {
        background: `linear-gradient(273.45deg, #8B3F9E 0%, #B77EC5 203.8%)`,
        color: theme.palette.white.main,
      },
    },
    "&.Audio": {
      background: `linear-gradient(273.45deg, #24713F 0%, #34A259 203.8%)`,
      padding: 3,
      "& $zoomVideoBoxInfo": {
        background: `linear-gradient(273.45deg, #24713F 0%, #34A259 203.8%)`,
      },
      "& $typeIcon": {
        background: `linear-gradient(273.45deg, #24713F 0%, #34A259 203.8%)`,
        color: theme.palette.white.main,
      },
    },
    "&.Course": {
      background: `linear-gradient(273.45deg, #1780C6 0%, #53A3D8 203.8%)`,
      padding: 3,
      "& $zoomVideoBoxInfo": {
        background: `linear-gradient(273.45deg, #1780C6 0%, #53A3D8 203.8%)`,
      },
      "& $typeIcon": {
        background: `linear-gradient(273.45deg, #1780C6 0%, #53A3D8 203.8%)`,
        color: theme.palette.white.main,
      },
    },
  },
  logoIcon: {
    position: "absolute",
    top: "0px",
    right: "0px",
    padding: "10px",
  },
  typeIcon: {
    position: "absolute",
    top: "10px",
    left: "10px",
    zIndex: 1,
    height: "32px",
    backgroundColor: "#F2E7F5",
    borderRadius: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transition: "all 0.8s ease-in-out",
    "& .MuiTypography-root": {
      opacity: 0,
      width: 0,
    },
  },
  contentTitle: {
    position: "absolute",
    bottom: "0px",
    left: "0px",
    right: 40,
    textAlign: "left",
    fontSize: "20px",
    fontWeight: 500,
    padding: 16,
    color: "var(--white)",
    zIndex: 1,
    "& h5": {
      fontSize: 20,
      [theme.breakpoints.down("lg")]: {
        fontSize: 16,
      },
      [theme.breakpoints.down("md")]: {
        fontSize: 14,
      },
    },
  },
  addPlusIcon: {
    position: "absolute",
    bottom: "0px",
    right: "0px",
    fontSize: "24px",
    fontWeight: 500,
    padding: 16,
    color: "var(--white)",
    zIndex: 1,
    "& svg": {
      width: 30,
      height: 30,
    },
  },
  contentDescription: {
    textAlign: "left",
    marginTop: 16,
    "& span": {
      fontSize: 12,
      color: "var(--gray)",
      fontWeight: 500,
      lineHeight: "15px",
    },
  },
  tag: {
    backgroundColor: "#FFE6D8",
    color: "#E87637",
    padding: "2px 10px",
    borderRadius: 4,
  },
  videoBoxInfo: {
    padding: 16,
    "& h6": {
      lineHeight: "normal",
      fontWeight: "normal",
      marginBottom: 15,
    },
    "& .MuiButton-root": {
      padding: 0,
      minWidth: "auto",
      fontWeight: "normal",
      "& .content": {
        textDecoration: "underline",
      },
    },
  },
  developmentProgress: {
    backgroundColor: "#FEF6EE",
    borderRadius: 8,
    padding: 10,
    flexWrap: "wrap",
    "& p": {
      color: theme.palette.orange.main,
    },
    "& .MuiLinearProgress-root": {
      width: 150,
      height: 8,
      flex: 1,
      borderRadius: 10,
      backgroundColor: "#D9D9D9",
      marginLeft: 10,
      marginRight: 5,
      "& .MuiLinearProgress-bar": {
        backgroundColor: theme.palette.orange.main,
      },
    },
  },
  videoSliderTrack: {
    "&.MuiSlider-root": {
      width: "100%",
      zIndex: 10,
      height: 6,
      color: theme.palette.primary.main,
      [theme.breakpoints.down("sm")]: {
        bottom: 50,
        left: 20,
        right: 20,
      },
      [theme.breakpoints.down("xsm")]: {
        bottom: 30,
        height: 5,
      },
      "& .MuiSlider-rail": {
        backgroundColor: "#EAEAEC",
        opacity: 1,
      },
      "& .MuiSlider-track": {
        backgroundColor: theme.palette.orange.main,
        border: 0,
      },
      "& .MuiSlider-thumb": {
        border: "4px solid #fff",
        display: "block",
        backgroundColor: theme.palette.orange.main,
      },
    },
  },
  videoVolumeTrack: {
    "&.MuiSlider-root": {
      width: 100,
      [theme.breakpoints.down("md")]: {
        width: 70,
      },
      [theme.breakpoints.down("sm")]: {
        width: 50,
      },
      "& .MuiSlider-rail": {
        backgroundColor: "#EAEAEC",
        opacity: 1,
      },
      "& .MuiSlider-track": {
        backgroundColor: theme.palette.orange.main,
        border: 0,
      },
      "& .MuiSlider-thumb": {
        border: "4px solid #fff",
        display: "block",
        backgroundColor: theme.palette.orange.main,
      },
    },
  },
  addIcon: {
    "&.MuiButtonBase-root": {
      width: 40,
      height: 40,
      backgroundColor: "#EAEDF0",
      color: "#000",
      "& svg": {
        width: 25,
        height: 25,
      },
    },
  },
  practiceSlider: {
    position: "relative",
    padding: "0 10px",
    "& .swiper-slide": {
      height: "auto",
    },
    "& .swiper-pagination": {
      position: "static",
      "& .swiper-pagination-bullet": {
        borderRadius: 5,
        width: 25,
      },
      "& .swiper-pagination-bullet-active": {
        width: 64,
        backgroundColor: theme.palette.orange.main,
      },
    },
    "& .button-prev": {
      position: "absolute",
      top: "50%",
      left: 0,
      color: "#747787",
      transform: "translateY(-50%)",
      boxShadow: `0px 0px 14px 0px #0000001A`,
      backgroundColor: theme.palette.white.main,
      width: 32,
      height: 32,
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      zIndex: 9,
      "&:after": {
        width: 20,
        height: 20,
      },
    },
    "& .button-next": {
      position: "absolute",
      top: "50%",
      right: 0,
      color: "#747787",
      transform: "translateY(-50%)",
      boxShadow: `0px 0px 14px 0px #0000001A`,
      backgroundColor: theme.palette.white.main,
      width: 32,
      height: 32,
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      zIndex: 9,
      "&:after": {
        width: 20,
        height: 20,
      },
    },
  },
  practiceBox: {
    boxShadow: `0px 0px 14px 0px #0000001A`,
    borderRadius: 10,
    padding: "16px 24px",
    height: "calc(100% - 20px)",
    border: `1px solid transparent`,
    margin: 10,
    "& h4": {
      fontSize: 28,
      fontWeight: "600",
      color: "#4F4F4F",
      [theme.breakpoints.down("sm")]: {
        fontSize: 24,
      },
      [theme.breakpoints.down("xts")]: {
        fontSize: 20,
      },
    },
    "& svg": {
      width: 32,
      height: 32,
      marginBottom: 10,
    },
  },
  downloadBox: {
    position: "relative",
    borderRadius: 10,
    margin: "0 10px",
    overflow: "hidden",
    border: "1px solid #CBCBCF",
    "&:before": {
      content: "''",
      background:
        "linear-gradient(135.55deg, rgba(0, 0, 0, 0) 57.87%, rgba(0, 0, 0, 0) 102.6%)",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      position: "absolute",
      zIndex: 0,
    },
    "&:after": {
      content: "''",
      background:
        "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%)",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      position: "absolute",
      zIndex: 0,
    },
    "& img": {
      width: "100%",
      display: "block",
    },
    "& $logoIcon": {
      position: "absolute",
      right: 10,
      top: 10,
      zIndex: 1,
      width: 40,
      height: 40,
      border: `1px solid #CBCBCF`,
      backgroundColor: theme.palette.white.main,
      borderRadius: 8,
      color: theme.palette.primary.main,
      visibility: "hidden",
      cursor: "pointer",
    },
    "&:hover": {
      "& $logoIcon": {
        visibility: "visible",
      },
    },
  },
  categoriesBox: {
    boxShadow: `0px 0px 30px 0px #4244501A`,
    padding: 28,
    maxHeight: "150px",
    height: "100%",
    borderRadius: 8,
    overflow: "hidden",
    position: "relative",
    backgroundColor: theme.palette.white.main,
    transition: "transform 0.6s ease, box-shadow 0.3s ease",
    "& h5": {
      marginBottom: 8,
    },
    "& a": {
      color: "#8B3F9E",
      "& span": {
        marginRight: 5,
        textDecoration: "underline",
      },
      "& svg": {
        verticalAlign: "middle",
      },
    },
    "&:hover": {
      boxShadow: `0px 0px 14px 0px #0000001A`,
      transform: "scale(1.05)",
      [theme.breakpoints.down("md")]: {
        transform: "scale(1)",
      },
    },
  },

  categoriesIcon: {
    position: "absolute",
    bottom: 0,
    right: 0,
    "& svg": {
      display: "block",
    },
  },
  viewTranscript: {
    color: theme.palette.orange.main,
    cursor: "pointer",
    [theme.breakpoints.down("xts")]: {
      fontSize: 14,
    },
    "& svg": {
      verticalAlign: "middle",
    },
  },
  audioImg: {
    height: "100%",
    "& img": {
      display: "block",
      width: "100%",
    },
  },
  audioDescription: {
    border: "1px solid #898994",
    backgroundColor: "#FBFBFB",
    padding: 15,
    borderRadius: 10,
    marginBottom: 20,
    "& p": {
      color: "#747787",
      marginBottom: 15,
      "& span": {
        color: "#202024",
        fontWeight: "bold",
      },
    },
  },
  courseImage: {
    borderRadius: 16,
    border: "1px solid #EAEAEC",
    overflow: "hidden",
    maxHeight: "644px",
    "&:before": {
      content: '""',
      background: `linear-gradient(254.68deg, rgba(255, 255, 255, 0) 69.62%, rgba(255, 255, 255, 0.8) 87.85%, rgba(255, 255, 255, 0.9) 93.92%, #FFFFFF 100%),
linear-gradient(90deg, rgba(255, 255, 255, 0.9) 19.18%, rgba(255, 255, 255, 0) 50.63%)`,
      position: "absolute",
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      zIndex: 1,
      opacity: 0.9,
    },
    "& img": {
      width: "100%",
      maxHeight: "644px",
      objectFit: "contain",
      display: "block",
    },
  },

  courseTitle: {
    position: "absolute",
    left: 0,
    bottom: 0,
    right: 0,
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    padding: 35,
    maxWidth: "40%",
    zIndex: 4,
    [theme.breakpoints.down("sm")]: {
      padding: 20,
    },
    "& h3": {
      fontWeight: "bold",
    },
  },
  topics: {
    display: "inline-flex",
    flexWrap: "wrap",
    gap: 10,
    alignItems: "center",
  },
  tableOfContents: {
    "& .MuiAccordion-root": {
      marginBottom: 0,
      "&:before": {
        content: "normal",
      },
      "&.Mui-expanded": {
        marginBottom: 0,
        "& .MuiAccordionSummary-root": {
          borderRadius: "10px 10px 0 0",
          borderBottom: 0,
        },
      },
      "& .MuiAccordionSummary-root": {
        borderRadius: "10px",
        minHeight: 48,
      },
      "& .MuiAccordionDetails-root": {
        overflow: "hidden",
        "& > .MuiBox-root": {
          "&:hover": {
            backgroundColor: "#F2E7F5",
          },
          "&:not(:last-child)": {
            borderBottom: "1px solid #CDD0E1",
          },
        },
      },
      "&:first-child": {
        "& .MuiAccordionDetails-root": {
          borderRadius: "10px 10px 0 0",
        },
      },
      "&:last-child": {
        "& .MuiAccordionDetails-root": {
          borderRadius: "0 0 10px 10px",
        },
      },
    },
  },
  presentationSliderWrapper: {
    "& .arrow-left, & .arrow-right": {
      width: 56,
      height: 56,
      borderRadius: 16,
      backgroundColor: `${theme.palette.white.main}80`,
      position: "absolute",
      left: 20,
      top: "50%",
      zIndex: 9,
      transform: "translateY(-50%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      [theme.breakpoints.down("sm")]: {
        width: 46,
        height: 46,
        borderRadius: 12,
      },
      "&.swiper-button-disabled": {
        opacity: 0.5,
      },
      "& svg": {
        width: 40,
        height: 40,
        [theme.breakpoints.down("sm")]: {
          width: 30,
          height: 30,
        },
      },
    },
    "& .arrow-right": {
      right: 20,
      left: "auto",
    },
  },
  presentationSlider: {
    "& .swiper-slide": {
      "& img": {
        height: 790,
        objectFit: "cover",
        [theme.breakpoints.down("lg")]: {
          height: 690,
        },
        [theme.breakpoints.down("md")]: {
          height: 590,
        },
        [theme.breakpoints.down("sm")]: {
          height: 490,
        },
        [theme.breakpoints.down("xsm")]: {
          height: 390,
        },
        [theme.breakpoints.down("xts")]: {
          height: 300,
        },
      },
    },
    "& .swiper-pagination": {
      bottom: 0,
      padding: 20,
      backgroundColor: "rgba(0,0,0,0.6)",
      left: 0,
      textAlign: "left",
      color: theme.palette.white.main,
    },
  },
  presentationSliderTrack: {
    position: "absolute",
    bottom: 10,
    right: 0,
    left: 0,
    zIndex: 9,
    textAlign: "right",
    "& .MuiSlider-root": {
      height: 8,
      color: theme.palette.orange.main,
      borderRadius: 0,
      padding: "0 !important",
      "& .MuiSlider-rail": {
        backgroundColor: theme.palette.white.main,
        opacity: 1,
      },
    },
  },
  zoomVideoBoxInfo: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "#0A0A0B",
    padding: 10,
    maxHeight: 95,
    height: "100%",
    "& svg": {
      color: theme.palette.white.main,
    },
    "& .MuiTypography-body1": {
      fontSize: 16,
      fontWeight: 700,
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      // "&:not($contentHead)": {
      //   position: "absolute",
      //   bottom: 10,
      //   left: 10,
      // },
    },
    "& .MuiTypography-body2": {
      fontSize: 14,
      fontWeight: 400,
      display: "-webkit-box",
      WebkitLineClamp: 1,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
    },
  },
  btnWrap: {
    position: "absolute",
    bottom: 10,
    left: 10,
    gap: 24,
    "& .MuiTypography-root": {
      display: "flex",
      alignItems: "center",
      gap: 6,
      "& span": {
        height: 20,
        width: 20,
        padding: "2px",
        borderRadius: "50%",
        backgroundColor: theme.palette.white.main,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& svg": {
          height: 14,
          width: 14,
        },
      },
    },
    "& svg": {
      verticalAlign: "middle",
    },
  },
  subText: {
    opacity: 0,
    visibility: "visible",
    height: 0,
    textAlign: "left",
    color: "#fff",
    display: "-webkit-box",
    WebkitLineClamp: 4,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontWeight: "300 !important",
    lineHeight: "130% !important",
  },
  zoomVideoBox: {
    transition: "all 0.8s ease-in-out",
    marginBottom: 20,
    "&:hover": {
      transform: "scale(1.15)",
      position: "relative",
      zIndex: 9,
      [theme.breakpoints.down("md")]: {
        transform: "scale(1)",
      },
      "& $typeIcon": {
        "& .MuiTypography-root": {
          opacity: 1,
          width: "auto",
          marginLeft: 4,
        },
      },
      "& $typeIcon, & $btnWrap, & $partnerLogo": {
        transform: "scale(0.85)",
        transition: "all 0.8s ease-in-out",
        transformOrigin: "left",
      },
      "& $zoomVideoBoxInfo": {
        backdropFilter: "blur(5px)",
        maxHeight: 1000,
        transition: "all 0.8s ease-in-out",
        "& $contentHead": {
          fontSize: 16,
          lineHeight: "1.2",
          fontWeight: 700,
          maxWidth: "100%",
          marginTop: "14%",
          WebkitLineClamp: 4,
        },
        "& $subText": {
          height: "100%",
          maxHeight: "4lh",
          opacity: 1,
          fontSize: 16,
          visibility: "visible",
          marginTop: 10,
          color: "#FFFFFF",
          WebkitLineClamp: 4,
          lineHeight: "120% !important",
        },
      },
      "&.Infographic": {
        "& $zoomVideoBoxInfo": {
          background: `linear-gradient(273.45deg, rgba(255, 177, 66, 0.7) 0%, rgba(255, 200, 123, 0.9) 203.8%)`,
        },
        "& $typeIcon": {
          background: theme.palette.white.main,
          color: "#E39424",
          opacity: 0.8,
        },
      },
      "&.Article": {
        "& $zoomVideoBoxInfo": {
          background: `#E87637A6`,
        },
        "& $typeIcon": {
          background: theme.palette.white.main,
          color: "#E87637",
          opacity: 0.8,
        },
      },
      "&.Presentation": {
        "& $zoomVideoBoxInfo": {
          background: `linear-gradient(273.45deg, rgba(85, 95, 221, 0.75) 0%, rgba(136, 160, 241, 0.75) 203.8%)`,
        },
        "& $typeIcon": {
          background: theme.palette.white.main,
          color: "#555FDD",
          opacity: 0.8,
        },
      },
      "&.Video": {
        "& $zoomVideoBoxInfo": {
          background: `linear-gradient(273.51deg, rgba(139, 63, 158, 0.57) 0%, rgba(139, 63, 158, 0.76) 100%)`,
        },
        "& $typeIcon": {
          background: theme.palette.white.main,
          color: "#8B3F9E",
          opacity: 0.8,
        },
      },
      "&.Audio": {
        "& $zoomVideoBoxInfo": {
          background: `background: linear-gradient(273.45deg, rgba(36, 113, 63, 0.6) 0%, rgba(52, 162, 89, 0.6) 203.8%)`,
        },
        "& $typeIcon": {
          background: theme.palette.white.main,
          color: "#2D8F4E",
          opacity: 0.8,
        },
      },
      "&.Course": {
        "& $zoomVideoBoxInfo": {
          background: `linear-gradient(273.45deg, rgba(23, 128, 198, 0.75) 0%, rgba(83, 163, 216, 0.75) 203.8%)`,
        },
        "& $typeIcon": {
          background: theme.palette.white.main,
          color: "#1780C6",
          opacity: 0.8,
        },
      },
    },
  },
}));
